import {
  useCallback,
  useEffect,
  useState,
} from "react";


import {
  getWebsiteCategories,
  getWebsiteProducts,
} from "../../../api/website-products/websiteProducts.api";


const useWebsiteProducts = () => {

  const [
    categories,
    setCategories,
  ] = useState([]);


  const [
    products,
    setProducts,
  ] = useState([]);


  const [
    search,
    setSearch,
  ] = useState("");


  const [
    categoryId,
    setCategoryId,
  ] = useState("");


  const [
    loading,
    setLoading,
  ] = useState(true);


  const [
    error,
    setError,
  ] = useState(null);


  const [
    pagination,
    setPagination,
  ] = useState({
    total: 0,
    page: 1,
    limit: 12,
    totalPages: 1,
  });


  /*
  |--------------------------------------------------------------------------
  | FETCH CATEGORIES
  |--------------------------------------------------------------------------
  */

  const fetchCategories = useCallback(
    async () => {

      try {

        const response =
          await getWebsiteCategories();


        setCategories(
          Array.isArray(response?.data)
            ? response.data
            : []
        );

      } catch (err) {

        console.error(
          "Failed to fetch website categories:",
          err
        );

        throw err;

      }

    },
    []
  );


  /*
  |--------------------------------------------------------------------------
  | FETCH PRODUCTS
  |--------------------------------------------------------------------------
  */

  const fetchProducts = useCallback(
    async () => {

      try {

        setLoading(true);

        setError(null);


        const response =
          await getWebsiteProducts({
            search,
            categoryId,
            page: 1,
            limit: 12,
          });


        setProducts(
          Array.isArray(
            response?.data?.products
          )
            ? response.data.products
            : []
        );


        setPagination(
          response?.data?.pagination || {
            total: 0,
            page: 1,
            limit: 12,
            totalPages: 1,
          }
        );

      } catch (err) {

        console.error(
          "Failed to fetch website products:",
          err
        );


        setError(
          err.response?.data?.message ||
          "Unable to load products."
        );


        setProducts([]);

      } finally {

        setLoading(false);

      }

    },
    [
      search,
      categoryId,
    ]
  );


  /*
  |--------------------------------------------------------------------------
  | LOAD CATEGORIES
  |--------------------------------------------------------------------------
  */

  useEffect(() => {

    const loadCategories =
      async () => {

        try {

          await fetchCategories();

        } catch (err) {

          console.error(
            "Failed to load categories:",
            err
          );

        }

      };


    loadCategories();

  }, [
    fetchCategories,
  ]);


  /*
  |--------------------------------------------------------------------------
  | LOAD PRODUCTS
  |--------------------------------------------------------------------------
  */

  useEffect(() => {

    fetchProducts();

  }, [
    fetchProducts,
  ]);


  return {

    categories,

    products,

    search,
    setSearch,

    categoryId,
    setCategoryId,

    loading,

    error,

    pagination,

  };

};


export default useWebsiteProducts;